import React from 'react';
import { Box, Chip, IconButton, Stack, Typography } from '@mui/material';
import Config from '../config/config';
import Iconify from './Iconify';

const SEM_IMAGEM = 'https://katuxa.sfo3.digitaloceanspaces.com/pdv/sem-imagem.jpg';

const CartItemResumo = ({ cartItem, removeFromCart }) => {
    const preco = parseFloat(cartItem.regular_price || 0).toFixed(2);
    const imgSrc =
        cartItem.images?.length > 0
            ? `${Config.base_fotos}/thumb/${cartItem.produto}_${cartItem.cor_produto}_01.jpg`
            : SEM_IMAGEM;

    return (
        <Box
            sx={{
                py: 1.25,
                borderBottom: '1px solid',
                borderColor: 'grey.200',
                '&:last-of-type': { borderBottom: 'none' },
                '&:hover .cart-item-remove': { opacity: 1 },
            }}
        >
            <Stack direction="row" spacing={1.25} alignItems="stretch">
                {/* Imagem */}
                <Box
                    component="img"
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: 1.25,
                        objectFit: 'cover',
                        bgcolor: 'grey.50',
                        border: '1px solid',
                        borderColor: 'grey.200',
                        flexShrink: 0,
                    }}
                    src={imgSrc}
                    alt={cartItem.use_descricao}
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = SEM_IMAGEM;
                    }}
                />

                {/* Info */}
                <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={0.5}>
                        <Typography
                            sx={{
                                fontSize: '0.82rem',
                                fontWeight: 700,
                                color: 'text.primary',
                                lineHeight: 1.3,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {cartItem.use_descricao}
                        </Typography>
                        <IconButton
                            className="cart-item-remove"
                            size="small"
                            onClick={() => removeFromCart(cartItem)}
                            aria-label="Remover item"
                            sx={{
                                p: 0.25,
                                color: 'grey.500',
                                opacity: { xs: 1, md: 0.4 },
                                transition: 'opacity 0.15s ease, color 0.15s ease',
                                '&:hover': { color: 'error.main', opacity: 1, bgcolor: 'error.lighter' },
                            }}
                        >
                            <Iconify width={16} icon="mdi:close" />
                        </IconButton>
                    </Stack>

                    {/* Chips de metadata */}
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
                        <Chip
                            size="small"
                            label={`Tam ${cartItem.grade}`}
                            sx={{
                                height: 18,
                                fontSize: 10,
                                fontWeight: 600,
                                bgcolor: 'grey.100',
                                color: 'text.primary',
                                '& .MuiChip-label': { px: 0.75 },
                            }}
                        />
                        <Chip
                            size="small"
                            label={cartItem.use_cor_produto}
                            sx={{
                                height: 18,
                                fontSize: 10,
                                fontWeight: 600,
                                bgcolor: 'grey.100',
                                color: 'text.primary',
                                '& .MuiChip-label': { px: 0.75 },
                            }}
                        />
                        <Chip
                            size="small"
                            label={`Loja ${cartItem.filial}`}
                            sx={{
                                height: 18,
                                fontSize: 10,
                                fontWeight: 600,
                                bgcolor: 'primary.lighter',
                                color: 'primary.dark',
                                '& .MuiChip-label': { px: 0.75 },
                            }}
                        />
                    </Stack>

                    {/* Linha inferior: ref + preço */}
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mt: 'auto', pt: 0.5 }}
                    >
                        <Typography sx={{ fontSize: '0.68rem', color: 'text.secondary' }}>
                            Ref {cartItem.use_referencia} · Cor {cartItem.use_cod_cor_produto}
                        </Typography>
                        <Typography sx={{ fontSize: '0.95rem', fontWeight: 800, color: 'text.primary' }}>
                            R$ {preco}
                        </Typography>
                    </Stack>
                </Box>
            </Stack>
        </Box>
    );
};

export default CartItemResumo;
